class ShopLookSlider {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelector('.shop-look__slides');
    this.slidesContainer = Array.from(section.querySelectorAll('.shop-look__slide'));
    this.dots = Array.from(section.querySelectorAll('.shop-look__dot'));
    this.prevBtn = section.querySelector('.shop-look__nav--prev');
    this.nextBtn = section.querySelector('.shop-look__nav--next');

    this.currentSlide = 0;
    this.totalSlides = this.slidesContainer.length;
    this.isAnimating = false;
    this.isMobile = this.checkIfMobile();

    if (this.totalSlides > 1 && !this.isMobile) {
      // Only initialize on desktop - mobile shows first look only
      this.setupDesktopLayout();
    }
  }

  checkIfMobile() {
    // Check if we're on mobile or if the window width is <= 768px
    return window.innerWidth <= 768;
  }

  setupDesktopLayout() {
    // On desktop, ensure all slides are visible
    this.slides.style.transform = 'none';
    this.slides.style.opacity = '1';
  }
}

// Initialize sliders (desktop only - mobile shows first look only)
function initShopLookSliders() {
  const sections = document.querySelectorAll('.shop-look');
  sections.forEach(section => {
    if (!section.hasAttribute('data-slider-initialized')) {
      new ShopLookSlider(section);
      section.setAttribute('data-slider-initialized', 'true');
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopLookSliders);
} else {
  initShopLookSliders();
}